import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'toolbar-default',
  templateUrl: './toolbar-default.component.html',
  styleUrls: ['./toolbar-default.component.css']
})
export class ToolbarDefaultComponent implements OnInit {

  constructor(private router: Router) {
  }

  ngOnInit() {
  }

  index() {
    this.router.navigate(['/']);
  }

}
